<script>
import VTime from "@/components/Clockin/VTime";
import VStartStop from "./VStartStop";
import dayjs from "dayjs";

export default {
    props: {
        month: {},
        year: {},
        logs: {}
    },
    components: { VTime, VStartStop },
    data() {
        return {
            daysOfWeek: [
                this.$t("dateRangePicker.Mon"),
                this.$t("dateRangePicker.Tue"),
                this.$t("dateRangePicker.Wed"),
                this.$t("dateRangePicker.Thu"),
                this.$t("dateRangePicker.Fri"),
                this.$t("dateRangePicker.Sat"),
                this.$t("dateRangePicker.Sun")
            ],
            calendarDays: []
        };
    },
    mounted() {
        this.generateCalendar(this.month, this.year);
    },
    methods: {
        generateCalendar(month, year) {
            const firstDayOfMonth = dayjs(`${year}-${month}-01`);
            const daysInMonth = firstDayOfMonth.daysInMonth();

            let daysArray = new Array();

            for (let i = 1; i <= daysInMonth; i++) {
                daysArray.push(i);
            }

            this.calendarDays = daysArray;
        },
        fmt(d) {
            return dayjs(`${this.year}-${this.month}-${d}`).format(
                "YYYY-MM-DD"
            );
        }
    }
};
</script>

<template>
    <div class="calendar-container">
        <!-- Calendar days -->
        <div class="calendar-table">
            <v-table class="table table-m table-sm">
                <v-thead>
                    <v-tr>
                        <v-th>{{ $t("daylogs.tbl_hdr_day") }}</v-th>
                        <v-th>{{ $t("daylogs.tbl_hdr_start_stop") }}</v-th>
                        <v-th class="text-right">{{
                            $t("daylogs.tbl_hdr_work_time")
                        }}</v-th>
                        <v-th class="text-right">{{
                            $t("daylogs.tbl_hdr_pause_time")
                        }}</v-th>

                        <v-th class="text-right">
                            {{ $t("daylogs.tbl_hdr_absence") }}</v-th
                        >
                        <v-th class="text-right">{{
                            $t("daylogs.tbl_hdr_total_time")
                        }}</v-th>
                        <v-th class="text-right">{{
                            $t("daylogs.tbl_hdr_goal")
                        }}</v-th>
                        <v-th class="text-right">{{
                            $t("daylogs.tbl_hdr_diff")
                        }}</v-th>
                        <v-th class="text-center">{{
                            $t("daylogs.tbl_hdr_in_lieu")
                        }}</v-th>
                        <v-th class="text-center">{{
                            $t("daylogs.tbl_hdr_status")
                        }}</v-th>
                    </v-tr>
                </v-thead>
                <v-tbody>
                    <v-tr
                        v-for="(day, index) in calendarDays"
                        @click="$emit('show-day', fmt(day))"
                        class="hoverable-row"
                        :class="{
                            'is-sun': logs[fmt(day)]['is_sun'],
                            'is-sat': logs[fmt(day)]['is_sat'],
                            'is-holiday': logs[fmt(day)]['is_holiday']
                        }"
                    >
                        <v-td class="text-center">
                            {{ day }}
                            <div class="small text-info text-bold">
                                {{ $d(new Date(fmt(day)), "dow") }}
                            </div>
                            <div class="text-danger small" v-if="logs[fmt(day)]['is_holiday']">
                                {{ logs[fmt(day)]['holiday_name'] }}
                            </div>
                        </v-td>
                        <template v-if="logs[fmt(day)]['daylog'] === null">
                            <v-td colspan="9" class=""></v-td>
                        </template>
                        <template v-else>
                            <v-td>
                                <template
                                    v-if="
                                        logs[fmt(day)]['daylog'][
                                            'time_start'
                                        ] === null &&
                                            logs[fmt(day)]['daylog'][
                                                'time_stop'
                                            ] === null
                                    "
                                >
                                    ---
                                </template>
                                <template v-else>
                                    <v-time
                                        :time="
                                            logs[fmt(day)]['daylog'][
                                                'time_start'
                                            ]
                                        "
                                    />
                                    -
                                    <template
                                        v-if="
                                            logs[fmt(day)]['daylog'][
                                                'time_stop'
                                            ] === null
                                        "
                                        ><i
                                            class="far fa-question-square text-warning"
                                        ></i
                                    ></template>
                                    <template v-else>
                                        <v-time
                                            :time="
                                                logs[fmt(day)]['daylog'][
                                                    'time_stop'
                                                ]
                                            "
                                    /></template>
                                </template>
                            </v-td>
                            <v-td
                                class="text-right"
                                :class="{
                                    'text-muted':
                                        logs[fmt(day)]['daylog']['work_time'] ==
                                        0
                                }"
                                >{{
                                    logs[fmt(day)]["daylog"]["work_time"]
                                        | toTime
                                }}</v-td
                            >
                            <v-td
                                class="text-right"
                                :class="{
                                    'text-muted':
                                        logs[fmt(day)]['daylog'][
                                            'pause_time'
                                        ] == 0
                                }"
                            >
                                {{
                                    logs[fmt(day)]["daylog"]["pause_time"]
                                        | toTime
                                }}
                            </v-td>
                            <v-td class="text-right">
                                <div
                                    :class="{
                                        'text-muted':
                                            logs[fmt(day)]['daylog'][
                                                'absence_sick_time'
                                            ] == 0
                                    }"
                                >
                                    <i class="far fa-fw fa-head-side-cough"></i>
                                    {{
                                        logs[fmt(day)]["daylog"][
                                            "absence_sick_time"
                                        ] | toTime
                                    }}
                                </div>

                                <div
                                    :class="{
                                        'text-muted':
                                            logs[fmt(day)]['daylog'][
                                                'absence_others'
                                            ] == 0
                                    }"
                                >
                                    <i class="far fa-user-slash"></i>
                                    {{
                                        logs[fmt(day)]["daylog"][
                                            "absence_others"
                                        ] | toTime
                                    }}
                                </div>

                                <div
                                    :class="{
                                        'text-muted':
                                            logs[fmt(day)]['daylog'][
                                                'absence_holiday_time'
                                            ] == 0
                                    }"
                                >
                                    <i class="far fa-tree-palm"></i>
                                    {{
                                        logs[fmt(day)]["daylog"][
                                            "absence_holiday_time"
                                        ] | toTime
                                    }}
                                </div></v-td
                            >
                            <v-td class="text-right">{{
                                logs[fmt(day)]["daylog"]["total_time"] | toTime
                            }}</v-td>
                            <v-td class="text-right">{{
                                logs[fmt(day)]["daylog"]["goal_time"] | toTime
                            }}</v-td>
                            <v-td
                                class="text-right"
                                :class="{
                                    'text-danger':
                                        logs[fmt(day)]['daylog']['diff_time'] <
                                        0
                                }"
                                >{{
                                    logs[fmt(day)]["daylog"]["diff_time"]
                                        | rTime
                                }}</v-td
                            >
                            <v-td class="text-center"
                                ><i
                                    class="far fa-check"
                                    v-if="
                                        logs[fmt(day)]['daylog'][
                                            'off_in_lieu'
                                        ] == 1
                                    "
                                ></i
                            ></v-td>
                            <v-td class="text-center"
                                ><template
                                    v-if="
                                        logs[fmt(day)]['daylog']['status'] === 0
                                    "
                                >
                                    <i class="far fa-empty-set"></i>
                                </template>
                                <template
                                    v-else-if="
                                        logs[fmt(day)]['daylog']['status'] === 1
                                    "
                                >
                                    <i
                                        class="fas fa-lock-open text-warning"
                                    ></i>
                                </template>
                                <template
                                    v-else-if="
                                        logs[fmt(day)]['daylog']['status'] === 2
                                    "
                                >
                                    <i
                                        class="fas fa-lock text-success"
                                    ></i> </template
                            ></v-td>
                        </template>
                    </v-tr>
                </v-tbody>
            </v-table>
        </div>
        <div class="calendar-row" v-if="false">
            <div
                v-for="(day, index) in calendarDays"
                :key="index"
                class="calendar-cell"
                :class="{ empty: !day }"
                @click="day ? $emit('show-day', fmt(day)) : false"
            >
                <div v-if="day">
                    <div class="d-day">{{ day || "" }}</div>
                    <div
                        v-if="logs[fmt(day)]['daylog']"
                        class="d-block day-contents"
                    >
                        <v-start-stop
                            :logs="logs"
                            :year="year"
                            :month="month"
                            :day="day"
                        />

                        <div v-if="true">
                            <i class="far fa-cog fa-spin fa-fw"></i>
                            {{ logs[fmt(day)]["daylog"]["work_time"] | toTime }}

                            <i class="far fa-pause-circle"></i>
                            {{
                                logs[fmt(day)]["daylog"]["pause_time"] | toTime
                            }}
                        </div>

                        <div v-if="true">
                            <i class="far fa-fw fa-head-side-cough"></i>
                            {{
                                logs[fmt(day)]["daylog"]["absence_sick_time"]
                                    | toTime
                            }}

                            <i class="far fa-fw fa-user-slash"></i>
                            {{
                                logs[fmt(day)]["daylog"]["absence_others"]
                                    | toTime
                            }}

                            <i class="far fa-fw fa-tree-palm"></i>
                            {{
                                logs[fmt(day)]["daylog"][
                                    "absence_holiday_time"
                                ] | toTime
                            }}
                        </div>

                        <div v-if="true">
                            <i class="far fa-sigma fa-fw"></i>
                            {{
                                logs[fmt(day)]["daylog"]["total_time"] | toTime
                            }}

                            <i class="far fa-balance-scale fa-fw"></i>
                            {{ logs[fmt(day)]["daylog"]["diff_time"] | rTime }}
                        </div>

                        <div class="text-center" v-if="true">
                            <template
                                v-if="logs[fmt(day)]['daylog']['status'] === 0"
                            >
                                <i class="far fa-empty-set"></i>
                            </template>
                            <template
                                v-else-if="
                                    logs[fmt(day)]['daylog']['status'] === 1
                                "
                            >
                                <i class="fas fa-lock-open text-warning"></i>
                            </template>
                            <template
                                v-else-if="
                                    logs[fmt(day)]['daylog']['status'] === 2
                                "
                            >
                                <i class="fas fa-lock text-success"></i>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.calendar-container {
    .hoverable-row {
        border-left: 3px solid inherit;
        &.is-sat {
            background: $gray-200;
            border-left: 3px solid $gray-300;
        }

        &.is-sun,
        &.is-holiday {
            background: $gray-300;
            border-left: 3px solid red;
        }        
        &:hover {
            background: $gray-100 !important;
            border-left: 3px solid $gray-100;
            cursor: pointer;
        }
    }

    display: flex;
    flex-direction: column;
    width: 100%;

    .absence {
        font-size: 13px;
    }

    .calendar-row {
        display: flex;
        flex-wrap: wrap;
    }

    .day-contents {
        position: relative;
        font-size: 13px;
    }

    .calendar-header {
        font-weight: bold;

        background: #f8f9fa;
    }

    .d-day {
        position: absolute;
        left: 4px;
        top: 4px;
        font-size: 14px;
        font-weight: bold;
    }

    .calendar-cell {
        &:hover {
            border: 1px solid $primary;
            background: $primary;
            color: white !important;
            cursor: pointer;
        }
        flex: 1;
        min-width: 14.285%; /* 100% / 7 for equal spacing */
        max-width: 14.285%;
        height: 136px;
        display: flex;
        justify-content: left;
        align-items: center;
        border: 1px solid #ddd;
        background-color: #fff;
        position: relative;
        padding-left: 12px;
    }

    .header {
        background: $gray-500;
        color: $default;
        height: 50px !important;
        font-weight: bold;
    }

    .empty {
        background: #f0f0f0;
        border: none;
    }
}
</style>
